var $ = require('jQuery');

module.exports = function() {
  function displayGatewayCredentials(ele) {
    $("div[id$='-credentials']").hide();
    $("div#" + ele + "-credentials").show();
  }

  $("#payment-gateway-selector").on('change', function() {
    displayGatewayCredentials($(this).val());
  });

  displayGatewayCredentials($("#payment-gateway-selector").val());

  let autosaveFormUponStripeConnectAuthorization = function () {
    let form = $(this).closest('form');
    let formSubmitUrl = form.attr('action');
    let redirectAfterSubmitUrl = $('#stripe-connect-auth-endpoint').data('url');

    let showLoader = function () {
      $('#loader').show().fadeTo(250, 0.8);
    };

    let hideLoader = function () {
      $('#loader').fadeTo(250, 0, function () { $(this).hide(); });
    };

    $.ajax({
      type: 'POST',
      url: formSubmitUrl,
      data: form.serializeArray(),
      success: function () {
        document.location = redirectAfterSubmitUrl;
      }
    });
    showLoader();
    return false;
  };

  $('#stripe-connect-authorise').click(autosaveFormUponStripeConnectAuthorization);
};
